import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import '../StyledComponents/Styles.css';
import { DotLoader } from "react-spinners";
import categories from '../StyledComponents/img/categories1 - Copy.png';
import deployed from '../StyledComponents/img/deployed_code_account.png';
import database from '../StyledComponents/img/database.png';
import shop from '../StyledComponents/img/shop_two.png';
import control from '../StyledComponents/img/control_point_duplicate.png';
import article from '../StyledComponents/img/article.png';
import local from '../StyledComponents/img/local_activity (1).png';
import logout from '../StyledComponents/img/logout (1).png';
import imag from '../StyledComponents/img/logo (11).png';
import imag1 from '../StyledComponents/img/image 26.png';
import imag2 from '../StyledComponents/img/Frame 2130 (1).png';
import imag3 from '../StyledComponents/img/group_add.png';
import imag4 from '../StyledComponents/img/group_add (1).png';
import imag5 from '../StyledComponents/img/group_add (2).png';
import imag6 from '../StyledComponents/img/error.png';
import { Link } from 'react-router-dom';
import UserList from './UserList';
import Revenue from './revenue';
import Subscription from './subscription';
import Tips from './tips';
import Result from './result';
import Voucher from './voucher';
import Logout from './logout';
import RunningUnits from './runningUnits';
import _ from "lodash"
import { verifyauthCheck, getDashboardStats } from "../handlers/adminApi";
import { formatPriceInUSD } from "../handlers/helpers";
import user from '../StyledComponents/img/user.png'

const Dashboard = () => {
    const [selectedItem, setSelectedItem] = useState(() => {
        return localStorage.getItem('selectedItem') || 'dashboard';
    }); const [showLogoutModal, setShowLogoutModal] = useState(false);
    const [dashboardStats, setDashboardStats] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();
    const hasRun = useRef(false);

    const authCheck = async () => {
        var resp = await verifyauthCheck();
        if (resp != null) {
            if (resp.status === true) {
                navigate(location.pathname, { state: { ...location.state, userData: resp.userData } })
            } else {
                navigate("/")
            }
        }
    };

    const getDashboardStatistics = async () => {
        setLoading(true); // Show loader
        var resp = await getDashboardStats();
        setDashboardStats(_.get(resp, 'data', []));
        setLoading(false);
    };

    useEffect(() => {
        if (!hasRun.current) {
            hasRun.current = true;
            authCheck();
            getDashboardStatistics();
        }
    }, []);
    useEffect(() => {
        localStorage.setItem('selectedItem', selectedItem);
    }, [selectedItem]);
    const userData = location.state?.userData;
    const renderContent = () => {
        if (loading) {
            return (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', marginLeft: '450px' }}>
                    <DotLoader color={"#F7812A"} loading={loading} size={60} />
                </div>
            );
        }

        switch (selectedItem) {
            case 'userlist':
                return <UserList />;
            case 'revenue':
                return <Revenue />;
            case 'subscription':
                return <Subscription />;
            case 'tips':
                return <Tips />;
            case 'result':
                return <Result />;
            case 'running units':
                return <RunningUnits />;
            case 'voucher':
                return <Voucher />;
            case 'logout':
                return <Logout />;
            default:
                return (
                    <div className="right">
                        <div className="title">
                            <h2>Admin Dashboard</h2>
                        </div>
                        <div className="right-inner">
                            <div className="item">
                                <div className="icon">
                                    <img src={imag2} alt="Total Users" />
                                </div>
                                <h3>Total Users</h3>
                                <h1>{_.get(dashboardStats, '[0].total_users', 0)}</h1>
                            </div>
                            <div className="item item-two">
                                <div className="icon">
                                    <img src={imag3} alt="Active Subscriptions" />
                                </div>
                                <h3>Active Subscriptions</h3>
                                <h1>{_.get(dashboardStats, '[0].active_subscriptions', 0)}</h1>
                            </div>
                            <div className="item">
                                <div className="icon">
                                    <img src={imag4} alt="Total Tips" />
                                </div>
                                <h3>Total Tips</h3>
                                <h1>{_.get(dashboardStats, '[0].total_tips', 0)}</h1>
                            </div>
                            <div className="item item-two">
                                <div className="icon">
                                    <img src={imag5} alt="Revenue Generated" />
                                </div>
                                <h3>Revenue Generated</h3>
                                <h1>{formatPriceInUSD(_.get(dashboardStats, '[0].total_revenue', 0) || 0)}</h1>
                            </div>

                        </div>
                    </div>
                );
        }
    };

    const handleLogoutConfirm = () => {
        setShowLogoutModal(false);
        localStorage.removeItem('token');
        localStorage.removeItem('selectedItem'); // Clear the selected item on logout

        navigate("/"); // Redirect to login page
    };

    const handleLogoutCancel = () => {
        setShowLogoutModal(false);
    };

    return (
        <div className="dash-main">
            <div className="top">
                <div className="top-inner">
                    <div className="logo">
                        <img src={imag} alt="Logo" className="logo-w" />
                    </div>
                    <div className="user">
                        <Link to="/whooska/admin/Profile">
                            <div className="imgs" style={{
                                display: 'inline-block',
                                backgroundColor: 'white',
                                borderRadius: '50%',
                                padding: '5px'
                            }}>
                                <img
                                    src={`${process.env.REACT_APP_API_HOSTNAME}${userData?.profileImage}`}
                                    alt="Profile"
                                    className="profile-image"
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = user;
                                    }}
                                    style={{
                                        width: '50px',
                                        height: '50px',
                                        borderRadius: '50%',
                                        objectFit: 'cover'
                                    }}
                                />
                            </div>

                        </Link>
                        <div className="text-content">
                            <h5 className="title">{_.get(userData, 'name', '')}</h5>
                        </div>
                    </div>
                </div>
            </div>

            <div className="middle">
                <div className="middle-inner">
                    <div className="left">
                        <div className={`item one ${selectedItem === 'dashboard' ? 'active' : ''}`} onClick={() => setSelectedItem('dashboard')}>
                            <img src={categories} alt="Dashboard Icon" />
                            <h4 className="txt">Dashboard</h4>
                        </div>
                        <div className={`item two ${selectedItem === 'userlist' ? 'active' : ''}`} onClick={() => setSelectedItem('userlist')}>
                            <img src={deployed} alt="User List" />
                            <h4>User List</h4>
                        </div>
                        <div className={`item two ${selectedItem === 'revenue' ? 'active' : ''}`} onClick={() => setSelectedItem('revenue')}>
                            <img src={database} alt="Revenue" />
                            <h4>Revenue</h4>
                        </div>
                        <div className={`item two ${selectedItem === 'subscription' ? 'active' : ''}`} onClick={() => setSelectedItem('subscription')}>
                            <img src={shop} alt="Subscription" />
                            <h4>Subscription</h4>
                        </div>
                        <div className={`item two ${selectedItem === 'tips' ? 'active' : ''}`} onClick={() => setSelectedItem('tips')}>
                            <img src={control} alt="Tips" />
                            <h4>Tips</h4>
                        </div>
                        <div className={`item two ${selectedItem === 'result' ? 'active' : ''}`} onClick={() => setSelectedItem('result')}>
                            <img src={article} alt="Result" />
                            <h4>Result</h4>
                        </div>
                        <div className={`item two ${selectedItem === 'running units' ? 'active' : ''}`} onClick={() => setSelectedItem('running units')}>
                            <img src={article} alt="Running Units" />
                            <h4>Running Units</h4>
                        </div>
                        <div className={`item two ${selectedItem === 'voucher' ? 'active' : ''}`} onClick={() => setSelectedItem('voucher')}>
                            <img src={local} alt="Voucher" />
                            <h4>Voucher</h4>
                        </div>
                        <div className={`item two ${selectedItem === 'logout' ? 'active' : ''}`} onClick={() => setShowLogoutModal(true)}>
                            <img src={logout} alt="Logout" />
                            <h4>Logout</h4>
                        </div>
                    </div>

                    {/* <div className="right" style={{ overflow: "hidden" }}> */}
                    <div className="right" >

                        {renderContent()}
                    </div>
                </div>
            </div>

            <div className="bottom">
                <div className="bottom-inner">
                    <div className="text-content">
                        <div className="copy">copyright @ WhooshkaTips</div>
                        <div className="text">
                            This page is for 18+ only. Gamble Responsibly. Visit{" "}
                            <span>www.gamblinghelponline.org.vic.au</span> or call <br />
                            Gambling Help on <span>1800 858 858</span>. The chances are you are about to lose.
                        </div>
                        <div className="policy">
                            Privacy Policy | Terms & Conditions
                        </div>
                    </div>
                </div>
            </div>

            {showLogoutModal && (
                <div className="modal">
                    <div className="modal-content">
                        <img src={imag6} alt="Confirm Logout" className="modal-image" />
                        <h2>Log Out</h2>
                        <h3>Are you sure you want to log out?</h3>
                        <div className="modal-buttons">
                            <button onClick={handleLogoutConfirm} className="confirm-btn">Confirm</button>
                            <button onClick={handleLogoutCancel} className="cancel-btn">Cancel</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Dashboard;
